import React from "react";

/** Ordered Studio create / edit flow steps. */
export const STUDIO_STEPS = [
  { id: "basics", label: "Setup" },
  { id: "files", label: "Files" },
  { id: "preference", label: "Deploy" },
  { id: "publish", label: "Publish" },
];

export default function StudioStepTabs({
  step,
  onSelect,
  steps = STUDIO_STEPS,
  ariaLabel = "Project steps",
}) {
  if (step === "done") return null;

  // Legacy "tracker" step folded into Setup
  const activeId = step === "tracker" ? "basics" : step;

  return (
    <div className="studio-steps" role="tablist" aria-label={ariaLabel}>
      {steps.map((s) => {
        const active = s.id === activeId;
        return (
          <button
            key={s.id}
            type="button"
            role="tab"
            aria-selected={active}
            className={`studio-step ${active ? "studio-step--active" : ""}`}
            onClick={() => onSelect(s.id)}
          >
            {s.label}
          </button>
        );
      })}
    </div>
  );
}
